module.exports = __webpack_public_path__ + "static/media/my_assets_pricateIcon.17847037.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_pricateIcon.png
// module id = 748
// module chunks = 0 1